/**
 * Created by Abner Sui on 07/19/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, Input, HostListener } from '@angular/core';
import { COLORS, ConditionalFormatting } from '../../../../tamalelibs/models/tile-column.model';
import { IdHelperService } from '../../../../services/id-helper.service';
import { FormulaBuilderService } from '../../../../widgets/formula-builder/formula-builder.service';
import { FormulaBuilderEventType } from '../../../../widgets/formula-builder/formula-builder.model';
import { take } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'tile-conditional-formatting',
    templateUrl: './tile-conditional-formatting.component.html',
    styleUrls: ['./tile-conditional-formatting.component.scss']
})
export class TileConditionalFormattingComponent implements OnInit {

    @Input() config: any; // config is any, but must be like {conditionalFormattings : [xxx]}
    @Input() fields: Array<any>; // any must be like {title: string, guid: stirng}
    @Input() hideBackground?: boolean;

    colors = COLORS;
    showPopup1: boolean;
    showPopup2: boolean;
    selectedFormat: ConditionalFormatting;
    isIPad: boolean;
    mouseOverFormatIndex: number;

    constructor(
        private _formulaBuilderService: FormulaBuilderService,
        private _deviceService: DeviceDetectorService,
    ) { }

    ngOnInit(): void {
        this.isIPad = this._deviceService.isMobile() || this._deviceService.isTablet();
    }

    @HostListener('document:click', ['$event'])
    clickSomewhere(event) {
        if (this.showPopup1) {
            this.showPopup1 = false;
        }
        if (this.showPopup2) {
            this.showPopup2 = false;
        }
    }

    addBackgroundColor(event, format: ConditionalFormatting) {
        this.selectedFormat = format;
        this.showPopup2 = !this.showPopup2;
        this.showPopup1 = false;
        this.emptyClick(event);
    }

    addColor(event, format: ConditionalFormatting) {
        this.selectedFormat = format;
        this.showPopup1 = !this.showPopup1;
        this.showPopup2 = false;
        this.emptyClick(event);
    }

    buildFormat(format: ConditionalFormatting) {
        this._formulaBuilderService.open({
            fields: this.fields,
            sourceId: format.id,
            formula: format.formula,
            formulaForData: format.formulaForData,
            isConditionalFormatting: true
        }).pipe(
            take(1),
        ).subscribe((data) => {
            this._handleForFormulaBuilder(data);
        });
    }

    chooseColor(color: string, format: ConditionalFormatting) {
        if (this.showPopup1) {
            format.color = color;
        } else if (this.showPopup2) {
            format.backgroundColor = color;
        }
    }

    deleteFormat(i) {
        this.config.conditionalFormattings.splice(i, 1);
        if (this.config.conditionalFormattings && this.config.conditionalFormattings.length === 0) {
            delete this.config.conditionalFormattings;
        }
    }

    emptyClick($event) {
        if ($event.preventDefault) {
            $event.preventDefault();
        }
        if ($event.stopPropagation) {
            $event.stopPropagation();
        }
    }

    onAddFormat() {
        const oneFormat: ConditionalFormatting = new ConditionalFormatting();
        oneFormat.id = IdHelperService.createGUID(1);
        if (!this.config.conditionalFormattings) {
            this.config.conditionalFormattings = [];
        }
        this.config.conditionalFormattings.push(oneFormat);
    }

    onMouseEnter(i) {
        this.mouseOverFormatIndex = i;
    }

    onMouseLeave() {
        this.mouseOverFormatIndex = null;
    }

    trackByFn(index) {
        return index;
    }

    private _handleForFormulaBuilder(event) {
        if (event.type === FormulaBuilderEventType.saveConditionalFormatting) {
            const sourceId = event.payload.sourceId;
            const formatIndex = this.config.conditionalFormattings.findIndex(item => item.id === sourceId);
            this.config.conditionalFormattings[formatIndex].formula = event.payload.formula;
            this.config.conditionalFormattings[formatIndex].formulaForData = event.payload.formulaForData;
        }
    }

}
